module.exports = __webpack_public_path__ + "static/icons/icon-legend-star-b4a98e3f6ba246039301ba78b07e6f24.svg";